// @flow

/**
 * Module dependencies.
 */

import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import { branch } from 'core/utils';
import { colors, columns, defaultTransition, fixedHeight, units } from 'client/styles';
import { isMobile } from 'client/core/utils';
import { position, size } from 'polished';
import { withSticky } from 'client/components/core/sticky-navbar/with-sticky';
import Icon from 'client/components/core/icon';
import React from 'react';
import TweenLite from 'gsap/src/uncompressed/TweenLite';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  isSticky: boolean,
  visibleAfter: number
};

/**
 * `Link` component.
 */

const ScrollToTop = styled.div`
  ${size(units(8))}

  background-color: ${colors.brandPrimary};
  bottom: ${fixedHeight.footer};
  color: ${colors.white};
  cursor: pointer;
  display: block;
  position: fixed;
  right: calc(${columns(1)}vw - ${units(4)});
  transition-property: opacity, transform;
  transition: ${defaultTransition};
  z-index: 2;

  ${({ active }) => `
    opacity: ${active ? 1 : 0};
    pointer-events: ${active ? 'all' : 'none'};
    transform: translateX(${active ? 0 : 25}%);
  `}

  span {
    ${position('absolute', '50%', null, null, '50%')}

    transform: translate(-50%, -50%);
    transition: transform ${defaultTransition};
  }

  &:hover {
    background-color: ${colors.brandSecondary};

    span {
      transform: translate(-50%, -70%);
    }
  }
`;

/**
 * Scroll document to top.
 */

function scrollDocumentToTop() {
  TweenLite.to(window, 0.5, { scrollTo: 0 });
}

/**
 * `ScrollTop` component.
 */

function ScrollTop({ isSticky }: Props): React$Element<*> {
  return branch(!isMobile(),
    <ScrollToTop
      active={isSticky}
      onClick={scrollDocumentToTop}
    >
      <Icon icon={'arrow-up'} />
    </ScrollToTop>
  );
}

/**
 * Export `ScrollTop`.
 */

export default withSticky(ScrollTop);



// WEBPACK FOOTER //
// ../src/client/components/core/scroll-top/index.js